// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { LogHandler } from "./handler.js";
